
export function SETPEOPLELIST(state, val) {
    state.peopleList = val
}
